function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["requestParams", "autoDictType", "responseFilter", "fillFields"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { AutoFillSuggest } from "../Form/Suggest";
import dict from "../Form/dict";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ExternalUserSuggest = function ExternalUserSuggest(props) {
  var requestParams = props.requestParams,
    autoDictType = props.autoDictType,
    responseFilter = props.responseFilter,
    _props$fillFields = props.fillFields,
    fillFields = _props$fillFields === void 0 ? [] : _props$fillFields,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(AutoFillSuggest, _objectSpread({
    usePage: false,
    url: "/ucenter/user/suggest",
    requestFilter: function requestFilter(_ref) {
      var keyword = _ref.keyword;
      return _objectSpread(_objectSpread({}, requestParams), {}, {
        key: keyword
      });
    },
    responseFilter: responseFilter || function (res) {
      return res.map(function (i) {
        return {
          label: "".concat(i.userName, "(").concat(i.userCode, ")"),
          value: i.userCode,
          origin: i
        };
      });
    },
    popupMatchSelectWidth: false,
    optionRender: function optionRender(option) {
      var _target$origin;
      var map = dict.getMap(autoDictType);
      var target = map[option.value];
      return /*#__PURE__*/_jsxs("div", {
        className: "max-w-[350px]",
        children: [/*#__PURE__*/_jsx("p", {
          className: "text-sm font-medium text-gray-900",
          children: option.label
        }), /*#__PURE__*/_jsx("p", {
          className: "text-xs font-normal whitespace-pre-wrap break-all text-zinc-500",
          children: target === null || target === void 0 || (_target$origin = target.origin) === null || _target$origin === void 0 ? void 0 : _target$origin.pathName
        })]
      }, option.value);
    },
    autoDictType: autoDictType,
    fillFields: fillFields
  }, rest));
};
export default ExternalUserSuggest;